import { z } from 'zod';

const jsonString = z.string().transform((val, ctx) => {
  try {
    return JSON.parse(val);
  } catch {
    ctx.addIssue({
      code: 'custom',
      message: 'Invalid JSON string',
    });
    return z.NEVER;
  }
});

export function jsonEncoded<T extends z.ZodTypeAny>(schema: T) {
  return jsonString.pipe(schema);
}

/**
 * A trimmed string that accepts either an empty value or a valid URL.
 * Useful for optional URL fields in forms where the user may leave the input
 * blank.
 */
export const optionalUrl = (message = 'Must be a valid URL') =>
  z
    .string()
    .trim()
    .pipe(z.union([z.literal(''), z.string().url(message)]));
